<template>
  <layout-register :step="step" md-title="9">
    <template #title-step>
      <span
        v-html="$t('m129', { awto: $store.getters['visualResources/appName'] })"
      ></span>
    </template>
    <div class="row">
      <div class="col-md-6 col-xs-12 col-10 mx-auto">
        <div class="card bg-onahau">
          <div class="card-media">
            <img
              src="@/assets/ilustracion-send-message.svg"
              alt=""
              class="card-media-img"
            />
          </div>
          <div class="card-text text-center">
            {{ $t('m130') }}
          </div>
        </div>
      </div>
      <div
        class="col-md-6 col-xs-12 col-10 justify-content-center d-flex flex-column mx-auto"
      >
        <p class="text-center">
          {{ $t('m131') }}
          <br class="d-none d-md-block" />
          <br class="d-none d-md-block" />
          {{ $t('m132') }}.
        </p>
      </div>
    </div>
    <div class="row" v-if="$store.getters['visualResources/appName'] == 'Awto'">
      <div class="col-md-10 col-12">
        <h2 class="primary--text md-text-center">
          {{ $t('m133') }}
        </h2>
      </div>
    </div>
    <div class="row" v-if="$store.getters['visualResources/appName'] == 'Awto'">
      <div class="col-md-6 col-xs-12 col-10 mx-auto">
        <div class="bg-card-frecuente">
          <img
            :src="require(`../assets/${this.urlImgMembership}.png`)"
            class="img-full"
          />
        </div>
      </div>
      <div
        class="col-md-6 col-xs-12 col-10 justify-content-center d-flex flex-column mx-auto"
      >
        <p class="secondary--text">
          <span class="pb-2 d-block md-text-center">
            <strong>{{ membership.name }}</strong>
          </span>
          <span class="md-text-center d-block">
            <strong>{{ priceFormat }} / {{ $t('m95') }}*</strong>
          </span>
        </p>
        <p>
          <span class="pb-2 d-block md-text-center">
            <strong> {{ $t('m134') }}: </strong> {{ payment }}.
          </span>
          <!--span class="md-text-center d-block">
            <strong> Fecha suscripción: </strong> 18/06/2020.
          </span-->
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-xs-12 col-12">
        <h3 class="secondary--text d-flex justify-content-center d-md-block">
          {{ $t('m135') }}
        </h3>
        <p class="d-flex justify-content-center d-md-block">
          {{ $t('m136') }}
        </p>
      </div>
      <div class="col-md-6 col-xs-12 col-12 my-auto">
        <ARowStore />
      </div>
    </div>
    <div class="row">
      <div class="col-md-7 col-xs-12 col-sm-12 col-12">
        <a-btn
          @click="finish"
          :loading="loading"
          class="next-step-button"
          primary
          type="submit"
        >
          {{ $t('m137') }}
        </a-btn>
      </div>
    </div>
  </layout-register>
</template>

<script>
import ARowStore from '@/components/ui/ARowStore';
import ABtn from '@/components/ui/ABtn';

export default {
  name: 'Finish',
  components: {
    ARowStore,
    ABtn,
  },
  data() {
    return {
      step: 10,
      nextBtnText: 'Finalizar mi registro',
      membership: {
        price: 0,
        name: '',
      },
      memberships: [
        {
          id: 13,
          name: 'Frecuente',
          price: 4990,
        },
        {
          id: 11,
          name: 'Cero',
          price: 0,
        },
      ],
      payment: '',
      numberFormat: new Intl.NumberFormat('de-DE'),
      loading: false,
    };
  },
  computed: {
    priceFormat() {
      return '$' + this.numberFormat.format(this.membership.price);
    },
    urlImgMembership() {
      let nameImg = '';

      if (this.membership.name === 'Frecuente') {
        nameImg = 'suscripcion-frecuente';
      } else {
        nameImg = 'suscripcion-cero';
      }

      return nameImg;
    },
  },
  methods: {
    finish(e) {
      e.preventDefault();
      this.$toast.success(this.$t('toast.redirectionTimeout'));
      this.$store.dispatch('appLogout');
      this.$store.dispatch('deleteSessionCookie');
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'login' });
      }, 1500);
    },
    getProfile() {
      this.$store.dispatch('register/profile').then(profile => {
        this.membership = this.memberships.find(
          element => element.id === profile.membershipId,
        );
        this.payment = profile.paymentMethod;
      });
    },
  },
  mounted() {
    this.getProfile();
    this.$store.getters['register/getPaymentMethodId'];
  },
};
</script>

<style lang="scss">
.card {
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
}

.card-text {
  padding-left: 16px;
  padding-right: 16px;
  &:last-child {
    padding-bottom: 16px;
  }
  &:first-child,
  .card-media + & {
    padding-top: 18px;
  }
}

.card-media {
  padding-left: 18px;
  padding-right: 18px;
  &:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    padding-top: 16px;
  }
  &-img {
    width: 100%;
  }
}

.bg-card-frecuente {
  margin-bottom: 1.5rem;
}
.img-full {
  width: 100%;
  height: auto;
}
</style>
